<template>
    <div class="stream">
        <div class="stream-head">
            <StreamName :is-access-allow="isAccessAllow" class="stream__name"/>
            <StreamObject :is-access-allow="isAccessAllow" class="stream__object"/>
        </div>

        <StageListTable class="stream__stage-list">
            <SubtaskStage
                :key="stage.id"
                v-for="stage in stages"
                :stage="stage"
                :is-access-allow="isAccessAllow"
                @updateStage="newStage => updateStage(newStage)"
                @deleteStage="deleteStage(stage.id)"
            />
        </StageListTable>

        <div class="stream__stage-errors" v-html="stagesErrors.join('<br>\n')"></div>

        <div class="stream-foot">
            <div class="stream__agent">
                <span class="stream-foot__key">Агент:</span>
                <StreamAgent v-if="isAccessAllow" class="stream-foot__value"/>
                <p v-else class="stream-url">{{stream.agent}}</p>
            </div>
            <div class="stream__url">
                <span class="stream-foot__key">Ссылка:</span>
                <StreamUrl
                    v-if="isAccessAllow"
                    class="stream-foot__value"
                    @error="v => stagesErrors = [v]"
                />
                <p v-else class="stream-url">{{stream.url}}</p>
            </div>
            <div class="stream__screenshot">
                <span class="stream-foot__key">Скриншот:</span>
                <StreamScreenshot
                    class="stream-foot__value"
                    :is-access-allow="isAccessAllow"
                    :streamId="stream.id"
                    :value="stream.screenshot"
                    :safe="stream.screenshot_safe"
                    @error="v => stagesErrors = [v]"
                />
            </div>
        </div>

        <div class="stream__content">
            <h3 class="stream-content__label">Контент</h3>
            <StreamContent v-if="isAccessAllow" class="stream-foot__value"/>
            <p v-else class="stream-content">{{ stream.content || 'контента нет' }}</p>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import SubtaskStage from "@/vue/plan/url/Task/SubtaskStage";
import StreamAgent from "@/vue/plan/url/Task/StreamAgent";
import StreamUrl from "@/vue/plan/url/Task/StreamUrl";
import StreamScreenshot from "@/vue/plan/url/Task/StreamScreenshot";
import StreamObject from "@/vue/plan/url/Task/StreamObject";
import StageListTable from "@/vue/plan/url/Task/StageListTable";
import StreamContent from "@/vue/plan/url/Task/StreamContent";
import StreamName from "@/vue/plan/url/Task/StreamName";

export default {
    name: "Subtask",
    components: {
        StreamName,
        StreamContent, StageListTable, StreamObject, StreamScreenshot, StreamUrl, StreamAgent, SubtaskStage
    },
    props: ['isAccessAllow'],
    data() {
        return {
            stagesErrors: [],
        };
    },
    computed: {
        ...mapState({
            stream: state => state.planUrl.selectedStream,
            stages: state => state.planUrl.selectedStreamStages,
            urlId: state => state.planCRUD.urlId,
            runId: state => state.planCRUD.runId,
            service: state => state.planCRUD.service,
        }),
    },
    methods: {
        deleteStage(stageId) {
            const afterDeleteStages = this.stages.filter(s => s.getId() !== stageId);
            // Not allowed
            if (afterDeleteStages.length) {
                this.updateStages(afterDeleteStages);
            }
        },
        updateStage(newStage) {
            // Replace updated data stage in list.
            this.updateStages(this.stages.map(stage => {
                if (stage.getId() === newStage.getId()) {
                    return newStage;
                }

                return stage;
            }))
        },
        /**
         * @param {PlanStageModel[]} stages
         */
        updateStages(stages) {
            this.$store.dispatch('updatePlanUrlStages', {
                streamId: this.stream.id,
                stageList: stages,
                service: this.service,
                runId: this.runId,
                urlId: this.urlId,
            })
                .then(response => {
                    this.stagesErrors = [];
                })
                .catch(e => {
                    if (Array.isArray(e.response.data.errors)) {
                        this.stagesErrors = e.response.data.errors;
                    }
                });
        },
        // updateStage(key, value) {
        //     const changedStageIdx = this.stages.findIndex(s => s.getId() !== this.stage.getId());
        //     this.stages[changedStageIdx] = this.stages[changedStageIdx].set(key, value);
        //
        //     this.$store.dispatch('updatePlanUrlStages', {
        //         streamId: this.stream.id,
        //         stageList: this.stages,
        //     });
        // },
    },
}
</script>

<style lang="scss">
.stream-head {
    margin-bottom: 1rem;

    .stream-prop {
        display: flex;
        align-items: center;
        margin-bottom: 0.5rem;
        line-height: 32px;
        white-space: nowrap;

        label {
            margin-bottom: 0;
        }

        &__label {
            margin-right: 5px;
        }

        &__value {
            min-width: 200px;
        }
    }
}

.stream-foot {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 30px;
    padding: 15px 0;
    line-height: 32px;
    white-space: nowrap;

    &__key {
        float: left;
        margin-right: 10px;
        font-weight: 700;
        font-size: 16px;
        color: #000000;
    }

    &__value {
        label {
            margin: 0;
        }

        .form-input {
            width: 100%;
        }

        .icon {
            min-width: 16px;
            height: 32px;
        }
    }
}

.stream {
    .icon {
        min-width: var(--size);
    }

    &__name {
        .form-input--group {
            min-width: 200px;
        }

        .stream-prop__value {
            font-weight: 700;
        }
    }

    &__stage-errors {
        margin: 10px auto 0;
        text-align: center;
        font-size: 13px;
        color: red;
    }

    &__agent {
        flex: 0 0 auto;
        width: 31.25%;
    }

    &__url {
        flex: 0 0 auto;
        width: 38.13%;
    }

    &__screenshot {
        flex: 0 0 auto;
        width: 26.88%;
    }
}

.stream-content {
    margin-bottom: 1rem;

    &__label {
        font-family: 'Inter', sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 22px;
        line-height: 27px;
        text-transform: uppercase;
        color: #30B68F;
    }

    &__value {
        height: 385px;
        min-height: 96px;
    }
}
</style>
